var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "up-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 12,
    height: 12,
    transform: "translate(199 1041)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_32",
    "data-name": "Mask Group 32",
    transform: "translate(211 1053) rotate(180)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_angle-down_",
    "data-name": "FontAwsome (angle-down)",
    d: "M5.333,160.259.215,155.141a.9.9,0,0,1,0-1.276l.85-.85a.9.9,0,0,1,1.276,0l3.627,3.627L9.6,153.015a.9.9,0,0,1,1.276,0l.85.85a.9.9,0,0,1,0,1.276L6.6,160.259a.9.9,0,0,1-1.272,0Z",
    transform: "translate(199.031 890.636)",
    fill: "#b1cb79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpArrow);
export default __webpack_public_path__ + "static/media/icon_up_arrow.705a937a487c0c6ec47bce2e07611d0a.svg";
export { ForwardRef as ReactComponent };